import { render } from "./modalEnable2Fa.vue?vue&type=template&id=6cfac842"
import script from "./modalEnable2Fa.vue?vue&type=script&lang=js"
export * from "./modalEnable2Fa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__